import StarRating from "@/components/design-system/star-rating";
import styles from "./productsGrid.module.scss";

export default function StarRatingOrPlaceholder({
  number_of_general_ratings,
  general_rating,
}: StarRatingOrPlaceholderProps) {
  if (number_of_general_ratings && number_of_general_ratings > 0) {
    return (
      <div className="d-flex align-items-center gap-2">
        <span className={styles.ratings}>
          <StarRating rating={general_rating} size="small" />
        </span>
        <span className={styles.ratingCount}>({number_of_general_ratings})</span>
      </div>
    );
  } else {
    return null;
  }
}

export type StarRatingOrPlaceholderProps = {
  number_of_general_ratings?: number;
  general_rating?: number;
};
